import { NewsBnrActionTypes } from "./constants";

interface NewsBnrActionType {
  type:
    | NewsBnrActionTypes.API_RESPONSE_SUCCESS
    | NewsBnrActionTypes.API_RESPONSE_ERROR
    | NewsBnrActionTypes.CREATE_NEWS_IMAGE
    | NewsBnrActionTypes.UPDATE_NEWS_IMAGE
    | NewsBnrActionTypes.GET_NEWS_IMAGE
    | NewsBnrActionTypes.DELETE_NEWS_IMAGE;
  payload: {} | string;
}

// common success
export const NewsBannerApiResponseSuccess = (
  actionType: string,
  data: any | {}
): NewsBnrActionType => ({
  type: NewsBnrActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const NewsBannerApiResponseError = (
  actionType: string,
  error: string
): NewsBnrActionType => ({
  type: NewsBnrActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const createNewsbanner = (
  banner_text: string,
  banner_text_ar: string,
  file: any
): NewsBnrActionType => ({
  type: NewsBnrActionTypes.CREATE_NEWS_IMAGE,
  payload: {
    file,
    banner_text_ar,
    banner_text,
  },
});

export const getNewsBanner = (): NewsBnrActionType => ({
  type: NewsBnrActionTypes.GET_NEWS_IMAGE,
  payload: {},
});

export const deleteNewsBanner = (id: string): NewsBnrActionType => ({
  type: NewsBnrActionTypes.DELETE_NEWS_IMAGE,
  payload: { id },
});
export const updateNewsBanner = (
  id: string,
  banner_text: string,
  banner_text_ar: string,
  file: any
): NewsBnrActionType => ({
  type: NewsBnrActionTypes.UPDATE_NEWS_IMAGE,
  payload: {
    id,
    file,
    banner_text_ar,
    banner_text,
  },
});
